import { Breadcrumb } from "../../components/ui";

const BreadCrumbs = ({ projectId, projectName }) => {
  return (
    <Breadcrumb
      items={[
        { label: "Home", href: "/" },
        { label: "Projects", href: "/projects" },
        { label: projectName || projectId },
      ]}
      className="mb-6"
    />
  );
};

export default BreadCrumbs;
